import React from 'react'

export default function Navbar(props) {
  return (
    <div>
      <nav className={`navbar navbar-expand-lg navbar-dark bg-${props.mode}`}>
        <div className="container-fluid">
          {/* eslint-disable-next-line */}
          <a className="navbar-brand" href="#">{props.name}</a>
          
            <div className="form-check form-switch text-light">
              <input className={`form-check-input bg-${props.mode}`} onClick={props.styling} type="checkbox" id="flexSwitchCheckDefault" />
              <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{props.myText}</label>
            </div>
        </div>
      </nav>
    </div>
  )
}
